import { UpdateProfessionalApprovalDTO } from "@/domain/dto/UpdateProfessionalApprovalDTO";
import { EProfessionalApprovalStatus } from "@/domain/enums/EProfessionalApprovalStatus";
import { ListProfessionalsQueryParamsDTO } from "@/domain/dto/ListProfessionalsQueryParamsDTO";
import endpoints from "@/infrastructure/http/endpoints";
import { EligibleProfessionalListResponseDTO } from "@/infrastructure/dto/EligibleProfessionalListResponseDTO";

import { NetworkService } from "@/services/NetworkService";
import { IProfessionalRemoteDataSource } from "../../interfaces/remote/IProfessionalRemoteDataSource";
import { ProfessionalDetailResponseDTO } from "@/infrastructure/dto/ProfessionalDetailResponseDTO";

export class ProfessionalRemoteDataSource implements IProfessionalRemoteDataSource {
    network
    constructor(ntw: NetworkService) {
        this.network = ntw
    }

    // Endpoint confirmado: GET admin/professionals/{userId} — o backend
    // reverteu a rota, é o id do usuário de novo (não o id do registro do
    // profissional). Shape do response (ProfessionalDetailResponseDataDTO)
    // já validado contra o payload real.
    getDetail(userId: string): Promise<ProfessionalDetailResponseDTO> {
        return this.network.get(`${endpoints.professionals}/${userId}`);
    }

    // Endpoint confirmado: PUT admin/professionals/{userId}/approve —
    // direção decidida pelo body, não pela URL (não existe rota de
    // "reprove"). { approved: true } aprova; { approved: false,
    // rejection_step, reason } reprova. {userId} é o id do usuário (o
    // backend reverteu a rota de volta pra esse id).
    async updateApproval(params: UpdateProfessionalApprovalDTO): Promise<void> {
        const approved = params.approved === EProfessionalApprovalStatus.APPROVED;
        const body: Record<string, unknown> = { approved };
        if (!approved) {
            body.rejection_step = params.rejection_step;
            body.reason = params.rejection_reason;
        }
        await this.network.put(`${endpoints.professionals}/${params.user_id}/approve`, body);
    }

    listProfessionals(params: ListProfessionalsQueryParamsDTO): Promise<EligibleProfessionalListResponseDTO> {
        return this.network.get(endpoints.professionals, params);
    }
}
